module.exports = __webpack_public_path__ + "static/media/SourceSansPro-SemiboldIt.5a3977d3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-SemiboldIt.woff
// module id = 345
// module chunks = 3